@if (zagLoading()) {
<span class="zag-button__spinner" aria-hidden="true"></span>
}
<ng-content select="[zagIcon]:not([zagEnd])"></ng-content>
<ng-content></ng-content>
<ng-content select="[zagIcon][zagEnd]"></ng-content>
